import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { IrisService } from '../shared/iris.service';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-voice-dashboard',
  templateUrl: './voice-dashboard.component.html',
  styleUrls: ['./voice-dashboard.component.scss']
})
export class VoiceDashboardComponent implements OnInit {
  contents: any[];
  titleColor: string;

  constructor(
    private translate: TranslateService,
    private irisSrv: IrisService,
    private router: Router,
  ) {
    console.log('voice-dashboard constructor');
    this.irisSrv.resetIndex();
  }

  ngOnInit() {
    this.contents = environment.voices;
    this.titleColor = environment.tiles[1].color;
  }

  public onClick(tag: string) {
    let options: string[] = [];
    tag = tag.replace('_nl', '');
    options.push(tag);
    this.irisSrv.activeRoot();
    this.router.navigate(['searchedboard'], { queryParams: { type: 'search.type_voice', options: options.toString() } });
  }

}
